import * as React from 'react';

import { H3 } from 'ha/ui/Headers';

interface Props {
  title: string;
  description: string;
}

const Benefit: React.SFC<Props> = ({ title, description }) => (
  <div className="color-white">
    <div className="supply-landing-benefit__line back-white" />
    <H3 className="m-y-1_5">{title}</H3>
    {description}
  </div>
);

export default Benefit;
